export type SlotEffect =
  null | "investigate" | "peek" | "special-election" | "execute" | "victory";
export function fascistSlotEffects(
  startingPlayers: number,
): readonly SlotEffect[] {
  if (
    !Number.isInteger(startingPlayers) ||
    startingPlayers < 5 ||
    startingPlayers > 10
  )
    throw new Error("Secret Hitler needs 5–10 starting players.");
  return [
    startingPlayers >= 9 ? "investigate" : null,
    startingPlayers >= 7 ? "investigate" : null,
    startingPlayers <= 6 ? "peek" : "special-election",
    "execute",
    "execute",
    "victory",
  ];
}
export const powerLabels: Record<string, string> = {
  investigate: "Investigate",
  peek: "Policy peek",
  "special-election": "Special election",
  execute: "Execution",
  victory: "Victory",
};
export const powerHelp: Record<string, string> = {
  investigate:
    "The president privately learns one player’s party membership, not their exact role. Each player may only be investigated once.",
  peek: "The president privately sees the next three policies. The deck order does not change.",
  "special-election":
    "The president chooses the next president. After that government, normal rotation resumes.",
  execute:
    "The president eliminates one player. Executing Hitler immediately wins for the Liberals; other roles stay secret.",
  victory: "The sixth Fascist policy wins for the Fascist team.",
  veto: "After five Fascist policies, the chancellor can request a veto. Both offices must agree; a veto advances the failed-election tracker.",
};
